export default __webpack_public_path__ + "static/media/termGreethand.6f0814b2.gif";